var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validProperties)?_c(_vm.fieldComponent,_vm._b({tag:"component",model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'component',_vm.properties,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }